module.exports = __webpack_public_path__ + "img/icon-16-filter-hover.22110ce5.svg";